export default function addEditShiftTemplate($uibModal, shiftTemplate) {
  return $uibModal.open({
    size: '620',
    controller: function addEditShiftTemplateCtrl() {
      this.shiftTemplate = shiftTemplate;
    },
    controllerAs: 'ctrl',
    template:
      '<edit-shift-template dismiss="$dismiss()" shift-template="ctrl.shiftTemplate" on-submit="$close(shiftTemplate)"></edit-shift-template>',
    backdrop: 'static',
  }).result;
}
